import {spanWrapText} from './libs.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.core.globals("ScrollTrigger", ScrollTrigger);

const setTopAnim = () => {
  const profile = document.querySelector('.section-profile');
  const title = profile.querySelectorAll('.headline__title');
  const bg = profile.querySelector('.profile-bg');
  const img = profile.querySelector('.profile-img');
  const text = profile.querySelector('.profile__text');
  const link = profile.querySelector('.profile-link');
  spanWrapText(title);
  const titleChar = title[0].querySelectorAll('.char');

  gsap.set(titleChar, {
    display: 'inline-block',
    opacity: 0,
    x: 30,
  })
  gsap.set(bg, {
    opacity: 0,
    clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
  })
  gsap.set(img, {
    opacity: 0,
    clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
  })
  gsap.set([text, link], {
    opacity: 0,
  })
  gsap.set(profile, {
    opacity: 1,
  })

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: profile,
      start: "top 75%",
    },
  })

  tl.to(titleChar, {
    opacity: 1,
    x: 0,
    duration: 1.4,
    ease: 'expo.out',
    stagger: {
      each: 0.05,
    }
  })
  .from(titleChar, {
    color: '#fff',
    duration: 2.2,
    ease: 'expo.out',
    stagger: {
      each: 0.05,
    }
  }, '<')
  .to(img, {
    opacity: 1,
    ease: 'sine.inOut',
    duration: .3,
  }, '<+=.2')
  .to(img, {
    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
    ease: 'expo.inOut',
    duration: .8,
  }, '<')
  .to(bg, {
    opacity: 1,
    ease: 'sine.inOut',
    duration: .3,
  }, '<+=.2')
  .to(bg, {
    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
    ease: 'expo.inOut',
    duration: .6,
  }, '<')
  .to([text, link], {
    opacity: 1,
    ease: 'sine.inOut',
    duration: .5,
  }, '<+=.4')
}

export default setTopAnim;